import WebsiteIcon from '@mui/icons-material/Language';

export default WebsiteIcon;
